var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useRef, useState } from 'react';
import Image from 'next/image';
import SubMenu from './SubMenu';
var NavItems = function (_a) {
    var navItem = _a.navItem, isLastMenuItem = _a.isLastMenuItem, handleSegmentEvents = _a.handleSegmentEvents, selectedTitle = _a.selectedTitle, isLoggedIn = _a.isLoggedIn;
    var subMenu = navItem.subMenu, link = navItem.link, title = navItem.title, handleClick = navItem.handleClick;
    var _b = __read(useState(''), 2), subMenuText = _b[0], setSubMenuText = _b[1];
    var ref = useRef();
    var isSelected = title === selectedTitle && isLoggedIn;
    useEffect(function () {
        var checkIfClickedOutside = function (e) {
            var _a;
            if ((_a = ref.current) === null || _a === void 0 ? void 0 : _a.contains(e.target)) {
                return;
            }
            setSubMenuText('');
        };
        document.addEventListener('click', checkIfClickedOutside);
        return function () {
            document.removeEventListener('click', checkIfClickedOutside);
        };
    }, []);
    var handleNavClick = function (text, link, isTargetBlank, handleClick) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!handleClick) return [3 /*break*/, 2];
                    return [4 /*yield*/, handleClick()];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    if (!handleSegmentEvents) return [3 /*break*/, 4];
                    return [4 /*yield*/, handleSegmentEvents(text)];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4:
                    window.open(link, isTargetBlank ? '_blank' : '_self');
                    return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement("div", { onClick: function () {
            setSubMenuText(function (prev) { return (prev === title ? '' : title); });
        }, ref: ref, className: "lfc-relative" }, subMenu ? (React.createElement("div", { className: "lfc-flex lfc-items-center lfc-gap-1 lfc-cursor-pointer lfc-relative" },
        React.createElement("p", { className: "lfc-font-bold lfc-text-[#443EFF] lfc-leading-6" }, title),
        React.createElement(Image, { className: "".concat(subMenuText === title ? 'lfc-rotate-180' : 'lfc-rotate-0', " lfc-transition-all"), src: 'https://ik.imagekit.io/onsnhxjshmp/SEO_project/pillar-pages/arrow-down-nav_RgHK4gTT3.svg', height: 20, width: 20, alt: "Open" }),
        subMenuText === title && (React.createElement(SubMenu, { menu: subMenu, isLastMenuItem: isLastMenuItem, handleSegmentEvents: handleSegmentEvents })))) : (React.createElement("button", { 
        // eslint-disable-next-line @typescript-eslint/no-misused-promises
        onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, handleNavClick(title, link, false, handleClick)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); }, className: "lfc-leading-6 lfc-cursor-pointer lfc-font-bold lfc-relative ".concat(isLoggedIn ? 'lfc-text-lg' : '', " ").concat(isSelected ? 'lfc-text-[#443EFF]' : '') },
        title,
        isSelected && React.createElement("div", { className: "lfc-h-1 lfc-w-full lfc-bg-[#443EFF] lfc-absolute lfc-mt-5 md:lfc-mt-[22px]" })))));
};
export default NavItems;
//# sourceMappingURL=index.js.map